import { render, staticRenderFns } from "./u-btn-text-fit-arrow.vue?vue&type=template&id=1922241c&scoped=true"
import script from "./u-btn-text-fit-arrow.vue?vue&type=script&lang=js"
export * from "./u-btn-text-fit-arrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1922241c",
  null
  
)

export default component.exports